import { css } from "lit";

export default css /*css*/ `
  design-menu {
    display: inline-flex;
    flex-flow: wrap;
    width: 100%;
    height: 100%;
    font-family: Lato, sans-serif;
  }

  /* Stil tanımları */
  .container {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    font-family: "League Spartan", sans-serif;
    background-color: #fcfcfcf2;
  }

  .css-renderer {
    z-index: 1;
    position: absolute;
    top: 0px;
    pointer-events: none;
  }

  .left-bar {
    position: absolute;

    width: 40px;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    margin-top: 10px;
    gap: 10px;
    z-index: 1;
  }

  .left-bar-item {
    height: 40px;
    background-color: #f7f7f7e6;
    border: 1px solid #e7e7e7;
    text-align: center;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    user-select: none;
    align-items: center;
  }

  .left-bar-item:hover {
    background-color: #ffffff;
    cursor: pointer;
  }

  .bottom-bar-group {
    position: absolute;
    top: 10px;
    left: 50%;
    translate: -50%;
    display: flex;
  }

  .bottom-bar-item {
    border-radius: 100%;
    background-color: #f7f7f7e6;
    border: 1px solid #e7e7e7;
    width: 55px;
    height: 55px;
    aspect-ratio: 1;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  .bottom-bar-item:hover {
    cursor: pointer;
    background-color: #eeeeee;
  }

  .container-svg {
    width: 25px;
    height: 25px;
  }

  .center {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .selected {
    color: #dd1818;
    fill: #dd1818;
  }

  .corner-button {
    background-color: #009587;
    color: #ffffff;
    border: 1px solid #808080;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    cursor: pointer;
    line-height: 0;
  }
`;
